export const formatPlaceholderToken = (placeholder: string): string => `__${placeholder.toUpperCase()}__`;

export const insertTextAtSelection = (source: string, text: string, selectionStart?: number, selectionEnd?: number): { next: string; cursor: number } => {
    const start = selectionStart ?? source.length;
    const end = selectionEnd ?? start;
    return {
        next: `${source.slice(0, start)}${text}${source.slice(end)}`,
        cursor: start + text.length
    };
};

const SAMPLE_PLACEHOLDER_VALUES: Record<string, string> = {
    FIRST_NAME: 'User One',
    LAST_NAME: 'User',
    EMAIL: 'user-001@example.test',
    SPOT: 'SPOT-A',
    SPOT_NAME: 'SPOT-A',
    SLOT: 'SLOT-A',
    SLOT_NAME: 'SLOT-A'
};

export const samplePlaceholderValue = (placeholder: string): string => {
    const key = placeholder.replace(/^__|__$/g, '').toUpperCase();
    return SAMPLE_PLACEHOLDER_VALUES[key] ?? `Sample ${key.replace(/_/g, ' ')}`;
};

export const applyPlaceholderValues = (source: string, values: Record<string, string> = {}): string =>
    source.replace(/__([A-Z0-9_]+)__/g, (_token, name: string) => values[name] ?? samplePlaceholderValue(name));
